<template>
  <div>
    <v-layout row wrap greyy v-if="showDashboard">
      <v-flex xs12 md8 offset-md2>
        <h1 class="top-heading">My Sales</h1>
      </v-flex>
      <v-flex v-if='loading' xs12 md8 offset-md2 mt-5 text-xs-center>
        <v-progress-circular
        indeterminate
        color="primary">
        </v-progress-circular>
      </v-flex>
      <v-flex v-else xs12 md8 offset-md2 mt-5 text-xs-center>
        <v-flex xs12 md6 left floatNone>
          <v-flex xs12>
            <v-flex xs12 paddingMobile>
              <div class="heading">This Month</div>
              <div class="heading amount mt-2" :class="getClass(thisMonth)">${{numberWithCommas(parseFloat(thisMonth).toFixed(2))}}</div>
              <div class="heading target">{{loggedInUser.position ? `Target = $${numberWithCommas(parseFloat(loggedInUser.position.target).toFixed(2))}` : ''}}</div>
            </v-flex>
          </v-flex>
          <v-flex xs12 mt-3 paddingMobile>
            <div class="heading">1 month prior</div>
            <div class="heading amount mt-2" :class="getClass(oneMonthPrior)">${{numberWithCommas(parseFloat(oneMonthPrior).toFixed(2))}}</div>
          </v-flex>
          <v-flex xs12 mt-3 paddingMobile>
            <div class="heading">2 month prior</div>
            <div class="heading amount mt-2" :class="getClass(twoMonthPrior)">${{numberWithCommas(parseFloat(twoMonthPrior).toFixed(2))}}</div>
          </v-flex>
          <v-flex xs12 mt-3 paddingMobile>
            <div class="heading">3 month prior</div>
            <div class="heading amount mt-2" :class="getClass(threeMonthPrior)">${{numberWithCommas(parseFloat(threeMonthPrior).toFixed(2))}}</div>
          </v-flex>
        </v-flex>
        <v-flex xs12 md6 right floatNone>
          <v-flex xs12>
            <v-flex xs12 paddingMobile>
              <div class="heading">Financial Year to Date</div>
              <div class="heading amount mt-2" :class="getClass(orderTotal/12)">${{numberWithCommas(parseFloat(orderTotal).toFixed(2))}}</div>
            </v-flex>
          </v-flex>
          <v-flex xs12 mt-5 pt-5 paddingMobile>
            <div class="heading pt-5">DIY Sales Today</div>
            <div class="heading amount mt-2" :class="getClass2(salesToday)">${{numberWithCommas(parseFloat(salesToday).toFixed(2))}}</div>
            <div class="heading target">{{loggedInUser.position ? `Target = $${numberWithCommas(parseFloat(setting.companyTarget).toFixed(2))}` : ''}}</div>
          </v-flex>
        </v-flex>

      </v-flex>
    </v-layout>
    <v-layout v-else row wrap greyy>
      <v-flex xs12 md8 offset-md2 mt-5 text-xs-center>
        <h1>Nothing to show</h1>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import OrderService from '@/services/OrderService'
import SettingService from '@/services/SettingService.js'
import moment from 'moment'
export default {
  props: {
  },
  data: () => ({
    loggedInUser: JSON.parse(atob(localStorage.getItem('user'))),
    setting: {},
    showDashboard: false,
    loading: false,
    userID: null,
    orderTotal: 0,
    thisMonth: 0,
    oneMonthPrior: 0,
    twoMonthPrior: 0,
    threeMonthPrior: 0,
    salesToday: null
  }),
  async mounted () {
    if (this.loggedInUser.email === 'books@diyblinds.com.au') {
      this.showDashboard = false
    } else if (this.loggedInUser.position && ['sales'].includes(this.loggedInUser.position.role)) {
      this.showDashboard = true
      this.userID = this.loggedInUser._id
      this.getSalesDataToday()
      this.getUserSalesData()
      this.getSetting()
    }
  },
  methods: {
    async getSetting () {
      const response = await SettingService.getSetting()
      this.setting = response.data.setting
    },
    getClass (boxValue) {
      if (boxValue >= this.loggedInUser.position.target) {
        return 'greenn'
      } else if (boxValue >= this.loggedInUser.position.target * 0.85) {
        return 'orangee'
      } else {
        return 'redd'
      }
    },
    getClass2 (boxValue) {
      if (boxValue >= this.setting.companyTarget) {
        return 'greenn'
      } else if (boxValue >= this.setting.companyTarget * 0.85) {
        return 'orangee'
      } else {
        return 'redd'
      }
    },
    async getSalesDataToday () {
      let todayResponse = await OrderService.getTodayTotal()
      if (todayResponse.data.todayTotal !== 0) {
        this.salesToday = parseFloat(todayResponse.data.todayTotal.toFixed(2)).toLocaleString()
      } else {
        this.salesToday = '0'
      }
    },
    async getUserSalesData () {
      this.loading = true
      let response = await OrderService.getUserSalesData(this.userID)
      let orders = response.data.orders
      var orderTotal = 0
      var thisMonth = 0
      var oneMonthPrior = 0
      var twoMonthPrior = 0
      var threeMonthPrior = 0
      for (let order of orders) {
        if (order.subTotal != null) {
          orderTotal += order.subTotal
          if (moment(order.date).isSame(new Date(), 'month')) {
            thisMonth += order.subTotal
          } else if (moment(order.date).add(1, 'months').isSame(new Date(), 'month')) {
            oneMonthPrior += order.subTotal
          } else if (moment(order.date).add(2, 'months').isSame(new Date(), 'month')) {
            twoMonthPrior += order.subTotal
          } else if (moment(order.date).add(3, 'months').isSame(new Date(), 'month')) {
            threeMonthPrior += order.subTotal
          }
        }
        if (order.shipping != null) {
          orderTotal += order.shipping
          if (moment(order.date).isSame(new Date(), 'month')) {
            thisMonth += order.shipping
          } else if (moment(order.date).add(1, 'months').isSame(new Date(), 'month')) {
            oneMonthPrior += order.shipping
          } else if (moment(order.date).add(2, 'months').isSame(new Date(), 'month')) {
            twoMonthPrior += order.shipping
          } else if (moment(order.date).add(3, 'months').isSame(new Date(), 'month')) {
            threeMonthPrior += order.shipping
          }
        }
        if (order.insurance != null) {
          orderTotal += order.insurance
          if (moment(order.date).isSame(new Date(), 'month')) {
            thisMonth += order.insurance
          } else if (moment(order.date).add(1, 'months').isSame(new Date(), 'month')) {
            oneMonthPrior += order.insurance
          } else if (moment(order.date).add(2, 'months').isSame(new Date(), 'month')) {
            twoMonthPrior += order.insurance
          } else if (moment(order.date).add(3, 'months').isSame(new Date(), 'month')) {
            threeMonthPrior += order.insurance
          }
        }
        if (order.install != null) {
          orderTotal += order.install
          if (moment(order.date).isSame(new Date(), 'month')) {
            thisMonth += order.install
          } else if (moment(order.date).add(1, 'months').isSame(new Date(), 'month')) {
            oneMonthPrior += order.install
          } else if (moment(order.date).add(2, 'months').isSame(new Date(), 'month')) {
            twoMonthPrior += order.install
          } else if (moment(order.date).add(3, 'months').isSame(new Date(), 'month')) {
            threeMonthPrior += order.install
          }
        }
        if (order.measure != null) {
          orderTotal += order.measure
          if (moment(order.date).isSame(new Date(), 'month')) {
            thisMonth += order.measure
          } else if (moment(order.date).add(1, 'months').isSame(new Date(), 'month')) {
            oneMonthPrior += order.measure
          } else if (moment(order.date).add(2, 'months').isSame(new Date(), 'month')) {
            twoMonthPrior += order.measure
          } else if (moment(order.date).add(3, 'months').isSame(new Date(), 'month')) {
            threeMonthPrior += order.measure
          }
        }
        if (order.discount != null) {
          orderTotal -= order.discount
          if (moment(order.date).isSame(new Date(), 'month')) {
            thisMonth -= order.discount
          } else if (moment(order.date).add(1, 'months').isSame(new Date(), 'month')) {
            oneMonthPrior -= order.discount
          } else if (moment(order.date).add(2, 'months').isSame(new Date(), 'month')) {
            twoMonthPrior -= order.discount
          } else if (moment(order.date).add(3, 'months').isSame(new Date(), 'month')) {
            threeMonthPrior -= order.discount
          }
        }
      }
      this.orderTotal = orderTotal
      this.thisMonth = thisMonth
      this.oneMonthPrior = oneMonthPrior
      this.twoMonthPrior = twoMonthPrior
      this.threeMonthPrior = threeMonthPrior
      this.loading = false
    },
    numberWithCommas (x) {
      if (x) {
        var parts = x.toString().split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        return parts.join('.')
      } else {
        return 0
      }
    }
  },
  components: {
  }
}
</script>

<style scoped>

.heading {
  width: 400px;
  max-width: 100%;
  font-size: 32px;
  font-weight: bold;
}
.top-heading {
  font-size: 36px;
  font-weight: bold;
}
.amount {
  border: 5px solid;
  border-radius: 30px;
  padding: 20px;
}
.target {
  color: #a4a8b0;
  font-style: italic;
}
.greyy {
  color: #565e6f;
}
.redd {
  color: #ee220c;
  border-color: #ee220c;
}
.orangee {
  color: #f27200;
  border-color: #f27200;
}
.greenn {
  color: #1db100;
  border-color: #1db100;
}
@media screen and (max-width: 661px) {
  .floatNone {
    float: none !important;
  }
  .top-heading {
    text-align: center;
  }
  .paddingMobile {
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MySales.vue